import { render, staticRenderFns } from "./battleNetUserAdd.vue?vue&type=template&id=286dbb06&scoped=true"
import script from "./battleNetUserAdd.vue?vue&type=script&lang=js"
export * from "./battleNetUserAdd.vue?vue&type=script&lang=js"
import style0 from "./battleNetUserAdd.vue?vue&type=style&index=0&id=286dbb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286dbb06",
  null
  
)

export default component.exports